import { declareString } from "@1js/localization";

export const NoAgentsPromptsHeading = declareString(
  "promptLibrary.noAgentsPromptsHeading",
  {
    text: "Agents haven’t been added to your library yet",
    comment:
      "Heading that appears on the collection page for no agent prompts in the results.",
  }
);

export const NoAgentsPromptsSubHeading = declareString(
  "promptLibrary.noAgentsPromptsSubHeading",
  {
    text: "When you or your organization creates agents, you’ll be able to access them here. Learn more about agents",
    comment:
      "sub Heading that appears on the collection page for no agent prompts in the results.",
  }
);

export const BrowseMicrosoftPromptsButton = declareString(
  "promptLibrary.browseMicrosoftPromptsButton",
  {
    text: "Browse Microsoft prompts",
    comment: "Text that appears on the button for no prompt results.",
  }
);

export const NoGroupPromptsHeading = declareString(
  "promptLibrary.noGroupPromptsHeading",
  {
    text: "Your teams haven’t shared any prompts yet",
    comment:
      "Heading that appears on the collection page for no group prompts in the results.",
  }
);

export const NoGroupPromptsSubHeading = declareString(
  "promptLibrary.noGroupPromptsSubHeading",
  {
    text: "When team members share prompts with you, you’ll be able to access them here. Check back later.",
    comment:
      "sub Heading that appears on the collection page for no group prompts in the results.",
  }
);

export const NoSavedPromptsHeading = declareString(
  "promptLibrary.noSavedPromptsHeading",
  {
    text: "You don’t have any saved prompts yet",
    comment:
      "Heading that appears on the collection page for no saved prompts in the results.",
  }
);

export const NoSavedPromptsSubHeading = declareString(
  "promptLibrary.noSavedPromptsSubHeading",
  {
    text: "Once you’ve saved a prompt, you’ll be able to find it here.",
    comment:
      "sub Heading that appears on the collection page for no saved prompts in the results.",
  }
);

export const NoLikedPromptsHeading = declareString(
  "promptLibrary.noLikedPromptsHeading",
  {
    text: "You haven’t liked any prompts yet",
    comment:
      "Heading that appears on the collection page for no liked prompts in the results.",
  }
);

export const NoLikedPromptsSubHeading = declareString(
  "promptLibrary.noLikedPromptsSubHeading",
  {
    text: "Prompts you like will be stored here for easy access.",
    comment:
      "sub Heading that appears on the collection page for no liked prompts in the results.",
  }
);

export const BrowsePromptsButtonLabel = declareString(
  "promptLibrary.browsePromptsButtonLabel",
  {
    text: "Browse prompts",
    comment: "Text that appears on the button for empty state prompt results.",
  }
);

export const NoWorkplacePromptsHeading = declareString(
  "promptLibrary.noWorkplacePromptsHeading",
  {
    text: "Your organization hasn’t added prompts to their library yet",
    comment:
      "Heading that appears on the collection page for no tenant prompts in the results.",
  }
);

export const NoWorkplacePromptsSubHeading = declareString(
  "promptLibrary.noWorkplacePromptsSubHeading",
  {
    text: "Once prompts have been added, you’ll be able to access prompts created and published by your organization here. In the meantime, get started with prompts provided by Microsoft.",
    comment:
      "sub Heading that appears on the collection page for no liked prompts in the results.",
  }
);
